import { Controller } from "@hotwired/stimulus";

let stripe;

export default class StripeController extends Controller {
  initialize() {
    stripe = Stripe(this.element.dataset.key);
  }

  connect() {
    let elements = stripe.elements();
    let elementStyles = {
      base: {
        color: "#222",
        fontWeight: 600,
        fontFamily: "Might Makes Regular",
        fontSize: "16px",
        fontSmoothing: "antialiased",
        ":focus": {
          color: "#151414"
        },
        "::placeholder": { color: getCssVar("--shore") },
        ":focus::placeholder": { color: getCssVar("--shore") }
      },
      invalid: {
        color: "#fff",
        ":focus": {
          color: "#FA755A"
        },
        "::placeholder": {
          color: "var(--gray)"
        }
      }
    };

    let elementClasses = {
      focus: "focus",
      empty: "empty",
      invalid: "invalid"
    };

    // Create Stripe Elements
    let cardNumber = elements.create("cardNumber", {
      style: elementStyles,
      classes: elementClasses
    });
    cardNumber.mount("#stripe-card-number");

    let cardExpiry = elements.create("cardExpiry", {
      style: elementStyles,
      classes: elementClasses
    });
    cardExpiry.mount("#stripe-card-expiry");

    let cardCvc = elements.create("cardCvc", {
      style: elementStyles,
      classes: elementClasses
    });
    cardCvc.mount("#stripe-card-cvc");

    // Register elements + validation
    this.registerElements([cardNumber, cardExpiry, cardCvc], "stripe_form");

    // Error handling for required + invalid
    cardNumber.on("change", (event) => {
      const errorEl = document.getElementById("error-number");
      if (event.empty) {
        errorEl.textContent = "Please enter card number.";
        errorEl.classList.remove("d-none");
      } else if (event.error) {
        errorEl.textContent = event.error.message;
        errorEl.classList.remove("d-none");
      } else {
        errorEl.classList.add("d-none");
      }
    });

    cardExpiry.on("change", (event) => {
      const errorEl = document.getElementById("error-expiry");
      if (event.empty) {
        errorEl.textContent = "Please enter expiry date.";
        errorEl.classList.remove("d-none");
      } else if (event.error) {
        errorEl.textContent = event.error.message;
        errorEl.classList.remove("d-none");
      } else {
        errorEl.classList.add("d-none");
      }
    });

    cardCvc.on("change", (event) => {
      const errorEl = document.getElementById("error-cvc");
      if (event.empty) {
        errorEl.textContent = "Please enter cvv.";
        errorEl.classList.remove("d-none");
      } else if (event.error) {
        errorEl.textContent = event.error.message;
        errorEl.classList.remove("d-none");
      } else {
        errorEl.classList.add("d-none");
      }
    });
  }

  registerElements(elements, exampleName) {
    let formClass = "." + exampleName;
    let example = document.querySelector(formClass);
    let form = example.querySelector("form");
    let error = form.querySelector(".error");

    let savedErrors = {};

    for (const [idx, element] of elements.entries()) {
      element.on("change", function (event) {
        if (event.error) {
          $("#new_user_card").find(".add-card").prop("disabled", true);
          error.classList.add("visible");
          savedErrors[idx] = event.error.message;
        } else {
          $("#new_user_card").find(".add-card").prop("disabled", false);
          savedErrors[idx] = null;
          let nextError = Object.keys(savedErrors)
            .sort((a, b) => a - b)
            .reduce(function (maybeFoundError, key) {
              return maybeFoundError || savedErrors[key];
            }, null);
          if (!nextError) {
            error.classList.remove("visible");
          }
        }
      });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      let hasEmpty = false;
      const requiredFields = [
        { element: elements[0], errorId: "error-number" },
        { element: elements[1], errorId: "error-expiry" },
        { element: elements[2], errorId: "error-cvc" }
      ];

      for (const { element, errorId } of requiredFields) {
        const errorEl = document.getElementById(errorId);
        if (element._empty) {
          errorEl.textContent = "This field is required.";
          errorEl.classList.remove("d-none");
          hasEmpty = true;
        }
      }

      if (hasEmpty) {
        $("#new_user_card").find(".add-card").prop("disabled", false);
        return;
      }

      if (
        $(form).valid() &&
        savedErrors[0] === null &&
        savedErrors[1] === null &&
        savedErrors[2] === null
      ) {
        $("#new_user_card")
          .find(".add-card")
          .prop("disabled", true)
          .html(
            "<span class=\"spinner-border spinner-border-sm\" aria-hidden=\"true\"></span>\n" +
            "  <span>Loading...</span>"
          );
      }

      example.classList.add("submitting");

      if (
        $(form).valid() &&
        savedErrors[0] === null &&
        savedErrors[1] === null &&
        savedErrors[2] === null
      ) {
        let additionalData = stripeData(form);

        stripe.createToken(elements[0], additionalData).then(function (result) {
          example.classList.remove("submitting");
          if (result.token) {
            example.classList.add("submitted");
            stripeTokenHandler(result.token);
          } else {
            $("#new_user_card").find(".add-card").prop("disabled", false);
          }
        });
      } else {
        $("#new_user_card").find(".add-card").prop("disabled", false);
      }
    });
  }

  change(e) {
    e.preventDefault();
    let d =
      $("#stripe-card-expiry").val().split("/")[0] +
      "/01/" +
      $("#stripe-card-expiry").val().split("/")[1];
    if (Date.parse(d) > Date.now()) {
      $("#stripe-card-expiry").removeClass("error");
    } else {
      $("#stripe-card-expiry").val("");
      $("#stripe-card-expiry").addClass("error");
    }
  }
}
function getCssVar(name) {
  return getComputedStyle(document.body).getPropertyValue(name).trim();
}

function stripeData(form) {
  let name_val = $(".name").val();
  let zip_val = $(".zip").val();
  let address1_val = $(".address1").val();
  let address2_val = $(".address2").val();
  let city_val = $(".city").val();
  let state_val = $(".state").val();
  let country_val = $(".country").val();
  let additionalData = {
    name: name_val || undefined,
    address_zip: zip_val || undefined,
    address_line1: address1_val || undefined,
    address_line2: address2_val || undefined,
    address_city: city_val || undefined,
    address_state: state_val || undefined,
    country: country_val || undefined
  };
  return additionalData;
}

function stripeTokenHandler(token) {
  let form = document.getElementById("new_user_card");
  let hiddenInput = document.createElement("input");
  hiddenInput.setAttribute("type", "hidden");
  hiddenInput.setAttribute("name", "stripeToken");
  hiddenInput.setAttribute("value", token.id);
  form.appendChild(hiddenInput);

  let redirect_url = form.dataset.redirectUrl;
  let url = form.getAttribute("action");
  let method = form.dataset.turboMethod;

  fetch(url, {
    method: method,
    headers: {
      Accept: redirect_url == null ? "text/vnd.turbo-stream.html" : "text/html",
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]")?.content || ""
    },
    body: JSON.stringify({
      stripeToken: token.id,
      is_wallet: document.getElementById("is_wallet").value,
      is_subscribe: document.getElementById("is_subscribe").value,
      is_order: document.getElementById("is_order").value,
      new_card:
        document.getElementById("new_card") == null
          ? false
          : document.getElementById("new_card").value,
      user_card: {
        user_id: $("#user_id").val(),
        address_1: $(".address1").val(),
        address_2: $(".address2").val(),
        city: $(".city").val(),
        state: $(".state").val(),
        postal_code: $(".zip").val(),
        name: $(".name").val(),
        country: $(".country").val()
      }
    })
  })
    .then((r) => {
      if (r.ok && !r.redirected) {
        return r.text();
      } else {
        if (r.redirected) {
          globalThis.location.href = r.url;
        }
        return r.text();
      }
    })
    .then((response) => {
      $("#new_user_card")
        .find(".add-card")
        .prop("disabled", false)
        .html(
          "<span class=\"text-black-border bg-text-white d-block transparent-bg-text fs-22 p-font-bold fst-italic\">" +
          ($("#new_card")?.val() === "true" ? "Add Card" : "Pay") +
          "</span>"
        );
      if (redirect_url === null || redirect_url === undefined) {
        let card_modal = document.getElementById("new-card-form");
        const modal = bootstrap.Modal.getInstance(card_modal);
        const errorRegex = /target="error"/;
        if (!errorRegex.exec(response)) {
          if (
            modal != null &&
            !["/showcases", "/shopping_bags/shopping_cart"].includes(
              globalThis.location.pathname
            )
          ) {
            modal.hide();
          } else if (modal != null) {
            // modal.show() // Commented to prevent modal from showing when payment is successful
          }
        }
        if (errorRegex.exec(response)) {
          $("#new_user_card")
            .find(".add-card")
            .prop("disabled", false)
            .html(
              "<span class=\"text-black-border bg-text-white d-block transparent-bg-text fs-22 p-font-bold fst-italic\">Pay</span>"
            );
        }
        Turbo.renderStreamMessage(response);
      } else {
        globalThis.location.href = redirect_url;
      }
    });
}
